import axios from 'axios'
import { store } from '../index'
import config from './config'

const tagsService = (() => {
  const getAllTagsData = () => {
    const authHeader = 'Bearer ' + (config.getAccessToken() || store.getState().auth.accessToken)
    return axios.get(config.apiUrl + '/tag/company', { headers: { Authorization: authHeader } })
  }

  return {
    getAllTagsData,
  }
})()

export default tagsService
